// extracted by mini-css-extract-plugin
export var canvasWrapper = "Actions-module--canvasWrapper--DORkg";
export var container = "Actions-module--container--TdBQI";